/**
 * FT20-U43 (FSD 3.2.4.3, R044/R045): the treasury alert console.
 *
 * The router spreads `TREASURY_ALERTS_ROUTES`; nav id `treasury-alerts` (section s-3.2.4)
 * points here. The route's permission is the one `GET /attention` declares,
 * `attention.item.read` — the console is a view of the caller's own attention list,
 * and who receives a treasury alert was decided when it was raised (the holders of
 * the alert's permission), so a narrower gate here would hide alerts the server
 * already delivered to this person.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ATTENTION_PERMISSIONS } from '@/modules/attention/permissions'

export const TREASURY_ALERTS_PATH = '/treasury/alerts'

export const TREASURY_ALERTS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/treasury/alerts',
    name: 'treasury-alerts',
    component: () => import('@/modules/treasury/alerts/TreasuryAlertConsoleView.vue'),
    meta: { titleKey: 'treasury.alertConsole.routeTitle', permission: ATTENTION_PERMISSIONS.itemRead },
  },
]
